import { OrganizationalUnitsRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: OrganizationalUnitsRepository,
): Interactor {
  return ({ planzone, filter }) =>
    present(
      repository
        .getAllOrganizationalUnits(filter)
        .then(({ organizationalUnits, totalPages }) => ({
          planzone,
          filter,
          organizationalUnits,
          totalPages,
        }))
        .catch(() => Promise.reject({ planzone, filter })),
    );
}

export type { Interactor };

export { createInteractor };
